import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BuildTwoToneSvg from "@ant-design/icons-svg/es/asn/BuildTwoTone";
import AntdIcon from "../components/AntdIcon";
var BuildTwoTone = function BuildTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BuildTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BuildTwoTone.displayName = 'BuildTwoTone';
}
export default /*#__PURE__*/React.forwardRef(BuildTwoTone);